
import axiosInstance from "../../apiAxios/axiosInstance";
export const getEnquriesList = async (payload) => {
  const response = await axiosInstance.post("/admin/all-enquiries-list", payload);
  return response.data;
};
export const getDeletedEnquriesList = async (payload) => {
  const response = await axiosInstance.post("/admin/all-enquiries-restore-list", payload);
  return response.data;
};

export const ViewEnquiry = async (payload) => {
  const response = await axiosInstance.post("/admin/contact-us-show", payload);
  return response.data;
};

export const DeleteEnquiry = async (payload) => {
  const response = await axiosInstance.post("/admin/all-enquiries-delete", payload);
  return response.data;
};

export const PermanentDeleteEnquiry = async (payload) => {
  const response = await axiosInstance.post("/admin/all-enquiries-permanent-delete", payload);
  return response.data;
};

export const ContactUsChangeStatus = async (payload) => {
  const response = await axiosInstance.post("/admin/all-enquiries-status-update", payload);
  return response.data;
};

export const RestoreEnquiry = async (payload) => {
  const response = await axiosInstance.post("/admin/all-enquiries-restore", payload);
  return response.data;
};


export const getVendorEnquiriesList = async (payload) => {
  const response = await axiosInstance.post("/admin/module-inquiry-list", payload);
  return response.data;
};


// ✅ Vendor View API (naya)
export const ViewVendorEnquiry = async (payload) => {
  const response = await axiosInstance.post("/admin/all-enquiries-show", payload);
  return response.data;
};

export const VendorEnquiryChangeStatus = async (payload) => {
  const response = await axiosInstance.post("/admin/module-inquiry-status-update", payload);
  return response.data;
};

export const VendorDeleteEnquiry = async (payload) => {
  const response = await axiosInstance.post("/admin/module-inquiry-delete", payload);
  return response.data;
};
